var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuBotTradeGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 12.2021H8.625C7.59119 12.2021 6.75 13.043 6.75 14.0771C6.75 15.1113 7.59119 15.9521 8.625 15.9521H15.375C16.4092 15.9521 17.25 15.1113 17.25 14.0771C17.25 13.043 16.4092 12.2021 15.375 12.2021ZM9.375 15.2021C8.75464 15.2021 8.25 14.6975 8.25 14.0771C8.25 13.4568 8.75464 12.9521 9.375 12.9521C9.99536 12.9521 10.5 13.4568 10.5 14.0771C10.5 14.6975 9.99536 15.2021 9.375 15.2021ZM14.625 15.2021C14.0046 15.2021 13.5 14.6975 13.5 14.0771C13.5 13.4568 14.0046 12.9521 14.625 12.9521C15.2454 12.9521 15.75 13.4568 15.75 14.0771C15.75 14.6975 15.2454 15.2021 14.625 15.2021ZM21.75 13.0212V6.88307C22.1856 6.72775 22.5 6.3154 22.5 5.82715C22.5 5.20679 21.9954 4.70215 21.375 4.70215C20.7546 4.70215 20.25 5.20679 20.25 5.82715C20.25 6.3154 20.5644 6.72775 21 6.88307V13.0212C20.8463 13.0761 20.707 13.1603 20.5922 13.2718C19.4489 9.614 16.0298 6.95215 12 6.95215C7.97049 6.95215 4.55122 9.61404 3.40782 13.2719C3.29306 13.1603 3.15372 13.0761 3 13.0212V6.88307C3.43556 6.72775 3.75 6.3154 3.75 5.82715C3.75 5.20679 3.24536 4.70215 2.625 4.70215C2.00464 4.70215 1.5 5.20679 1.5 5.82715C1.5 6.3154 1.81444 6.72775 2.25 6.88307V13.0212C1.81444 13.1765 1.5 13.5889 1.5 14.0771V17.0771C1.5 17.6975 2.00464 18.2021 2.625 18.2021C2.97807 18.2021 3.28976 18.0354 3.49617 17.7802C4.14001 18.921 5.34933 19.7021 6.75 19.7021H17.25C18.6507 19.7021 19.86 18.921 20.5038 17.7802C20.7102 18.0354 21.0219 18.2021 21.375 18.2021C21.9954 18.2021 22.5 17.6975 22.5 17.0771V14.0771C22.5 13.5889 22.1856 13.1765 21.75 13.0212ZM15.375 16.7021H8.625C7.17773 16.7021 6 15.5244 6 14.0771C6 12.6299 7.17773 11.4521 8.625 11.4521H15.375C16.8223 11.4521 18 12.6299 18 14.0771C18 15.5244 16.8223 16.7021 15.375 16.7021Z",
    fill: "url(#paint0_linear_2629_36507)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2629_36507",
    x1: 1.5,
    y1: 12.2027,
    x2: 22.5,
    y2: 12.2027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBotTradeGold);
export default __webpack_public_path__ + "static/media/Menu_Bot_Trade_Gold.5b2e2d35f10ac467921ad658a90f3a95.svg";
export { ForwardRef as ReactComponent };